import { useEffect, useRef, useState } from "react";
import { GameShell, useGameLoop, beep } from "./_gameKit";

const COLORS = ["#00F0FF","#39FF14","#FFE300","#FF003C"];

export default function JixxeoColorMatch() {
  const canvasRef = useRef(null);
  const [running, setRunning] = useState(true);
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const [best, setBest] = useState(() => Number(localStorage.getItem("jixxeo_color_best") || 0));
  const fallingRef = useRef({ x: 240, y: -50, color: COLORS[0], v: 200 });

  const spawnNext = (w) => {
    fallingRef.current = { x: 50 + Math.random() * (w - 100), y: -50, color: COLORS[Math.floor(Math.random() * 4)], v: 180 + score * 6 };
  };

  const tap = (c) => {
    if (!running) return;
    if (c === fallingRef.current.color) {
      beep(880, 0.1);
      setScore((s) => s + 1);
      spawnNext(canvasRef.current.width);
    } else {
      beep(160, 0.2);
      setLives((l) => {
        const nl = l - 1;
        if (nl <= 0) setRunning(false);
        return nl;
      });
    }
  };

  useGameLoop(canvasRef, ({ ctx, w, h, dt }) => {
    ctx.fillStyle = "#050510"; ctx.fillRect(0, 0, w, h);
    if (running) fallingRef.current.y += fallingRef.current.v * dt;
    if (fallingRef.current.y > h - 100) {
      // missed — costs a life
      beep(200, 0.2);
      setLives((l) => {
        const nl = l - 1;
        if (nl <= 0) setRunning(false);
        return nl;
      });
      spawnNext(w);
    }
    const f = fallingRef.current;
    ctx.fillStyle = f.color; ctx.shadowColor = f.color; ctx.shadowBlur = 24;
    ctx.beginPath(); ctx.arc(f.x, f.y, 22, 0, Math.PI * 2); ctx.fill();
    ctx.shadowBlur = 0;
    // Target zone
    ctx.strokeStyle = "rgba(255,255,255,0.2)";
    ctx.setLineDash([6, 6]);
    ctx.beginPath(); ctx.moveTo(0, h - 100); ctx.lineTo(w, h - 100); ctx.stroke();
    ctx.setLineDash([]);
  }, running);

  useEffect(() => {
    if (!running && score > best) { setBest(score); localStorage.setItem("jixxeo_color_best", String(score)); }
  }, [running, score, best]);

  const restart = () => {
    setScore(0); setLives(3); setRunning(true);
    setTimeout(() => spawnNext(canvasRef.current.width), 30);
  };

  return (
    <>
      <GameShell canvasRef={canvasRef} title="Jixxeo Color Match" accent="#39FF14"
      adGame="jixxeo-color-match"
        chips={[["Score", score], ["Lives", "♥".repeat(Math.max(0, lives))], ["Best", best]]}
        instructions="Tap the button that matches the falling color"
        gameOver={!running ? { title: "Game Over", subtitle: `${score} matches` } : null}
        onRestart={restart}
      />
      <div className="fixed inset-x-0 bottom-6 flex justify-center gap-3 z-30">
        {COLORS.map((c) => (
          <button key={c} onClick={() => tap(c)}
            className="w-14 h-14 rounded-full border-2"
            style={{ background: c, borderColor: "#050510", boxShadow: `0 0 20px ${c}` }} />
        ))}
      </div>
    </>
  );
}
